const firebaseConfig = {
    apiKey: "AIzaSyDZVKrvSEid3xQutwQjGvlstqR2-RLqeqc",
    authDomain: "bird-box-f16a6.firebaseapp.com",
    projectId: "bird-box-f16a6",
    storageBucket: "bird-box-f16a6.appspot.com",
    messagingSenderId: "555231749093",
    appId: "1:555231749093:web:81362adc0eedca74e9850c"
  };
  export default firebaseConfig;